exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.linked-card::after {\n  width: 1px;\n  content: ' ';\n  border: 1px solid #e5e5e5;\n  height: 17px;\n  top: 100%;\n  position: absolute;\n  left: 32px;\n}\n", ""]);

